<template>
    <div class="supportMains">
        <div class="buttonDiv">
            <a-button size="small" class="submitBtn" @click="submit">{{$t('support.submit')}}</a-button>
            <a-button size="small" class="submitBtn" @click="reset">{{$t('support.reset')}}</a-button>
        </div>
        <a-form :form="form">
        <a-col class="supportColumns">
            <a-row >
                <a-form-item  class="genericFrom" >
                   <b>{{$t('support.a01ReopenASNAsn')}}</b>
                   <a-input size="small" style="width: 300px" ref="asn" v-decorator="['ASN']" @pressEnter="submit"/>
                </a-form-item>
            </a-row>
            <a-row class="noteColumns">
                <b>{{$t('support.note')}}</b>
                <div>
                    <a-textarea disabled v-model="note" class="noteText" style="color: black;;height: 200px"/>
                </div>
            </a-row>
        </a-col>
        </a-form>
    </div>
</template>
<script>
    import Vue from 'vue'
    import VueResource from 'vue-resource'
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    // import axios from 'axios';
    Vue.use(VueResource)
    export default{
        props:{
            orgId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            projectId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            url: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        components:{
        },
        data(){
            return{
                form: this.$form.createForm(this, {}),
                supportType:"A01ReopenASN",
                note:"",
            }
        },
        methods:{
            submit(){
                if(null==this.$refs.asn.value||this.$refs.asn.value.length<=0){
                    this.note="请输入ASN#";
                    this.$refs.asn.value="";
                    return;
                }
                var params = {};
                params.supportType = this.supportType;
                params.asn = this.$refs.asn.value;
                params.orgId = this.orgId;
                params.projectId = this.projectId;
                params.url = this.url;
                ajax.get(api.SENDSUPPORTA01REOPENASN,params).then(res=>{
                    if(res.code == 200){
                        this.note="ASN# " + this.$refs.asn.value + "已经回滚至Fully RCVD / Partially RCVD";
                        this.saveLog(params,"true","Succeed")
                    }else{
                        this.saveLog(params,"false",res.msg)
                        this.note=res.msg;
                    }
                })
            },
            saveLog(params,isSuccess,msg){
                let paramsLog = {
                    supportType: this.supportType,
                    params: JSON.stringify(params),
                    isSuccess: isSuccess,
                    returnMsg:msg
                }
                let that = this;
                ajax.get(api.SUPPORTSAVELOG,paramsLog).then(res=>{
                    if(res.code == 200){
                        that.$refs.asn.value="";
                    }else{
                        that.note=res.msg;
                    }
                })
            },
            reset(){
                this.$refs.asn.value="";
                this.note="";
            }
        }
    }
</script>